import { m } from '../paraglide/messages'

export function balanceLabel(balance: number): string {
  const amount = Math.abs(balance)
  if (balance < 0) return m.balance_to_pay({ amount: amount.toFixed(2) })
  if (balance > 0) return m.balance_in_credit({ amount: amount.toFixed(2) })
  return m.balance_settled()
}

// Short version for tight spaces (e.g. table cells).
export function balanceShort(balance: number): string {
  const amount = Math.abs(balance)
  if (balance < 0) return m.balance_short_to_pay({ amount: amount.toFixed(0) })
  if (balance > 0) return m.balance_short_credit({ amount: amount.toFixed(0) })
  return m.balance_short_settled()
}
